/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Inbound_Field_Gross_WeightInputs */

const en_inbound_field_gross_weight = /** @type {(inputs: Inbound_Field_Gross_WeightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gross weight (kg)`)
};

/**
* | output |
* | --- |
* | "Gross weight (kg)" |
*
* @param {Inbound_Field_Gross_WeightInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const inbound_field_gross_weight = /** @type {((inputs?: Inbound_Field_Gross_WeightInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Inbound_Field_Gross_WeightInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_inbound_field_gross_weight(inputs)
});